import axios from 'axios';

export const apiUrl = `https://web-service.nashresra.com/api/v1/`;

let links = {
  baseUrl: apiUrl,
};
const { baseUrl,  } = links;

const defaultOptions = {
  baseURL: baseUrl,
  headers: {
    'Accept' : 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
};

let instance = axios.create(defaultOptions);

instance.interceptors.request.use(function (config) {
  const token = localStorage.getItem('token');
  // const token = "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NDNhYWVlOC1kNDMwLTQ2NDItYjkwMy0wMTNjZWQ4NzhiZDQiLCJqdGkiOiJiZTFjMThhMDUyOWNhYTgxMmZmMGYzMzE0ZTA4NmY4OWE4YzA0OGQ2ZDY4ZTFmY2VlNjViYmFhMDk1ZmY1YjZiMGYyNDBkZjI0YmEyMzM0YiIsImlhdCI6MTYzMDc1MjU2Mi43NzA0MTYsIm5iZiI6MTYzMDc1MjU2Mi43NzA0MiwiZXhwIjoxNjYyMjg4NTYyLjc2NjMxNiwic3ViIjoiZDgyMmMwMTYtNDliZC00MjVjLWEwOWYtNzVlYmNlYmZiMmZkIiwic2NvcGVzIjpbXX0.pkec02QdF6Q_i-IxJUFpyw93LUHGgKhtcH-MC8brvwSyIOJitndJvnbXgN-gNp9o1CAKHgE5rrA4KH4GUHLk7Oa0lQiiANCEmion5wPRWrjsPMhGpWSnfIse0WrmfN6fSJ1jtYjfrxjR40t28dTaYhsE4bT_IdJrxHRDugXij4MA1KW77WLKTGa_eZEGE-xMogmwGYGnoQ4-M3mG0PN_FQpzHvhaUZ4pCBbt6Es5h_jKYcaCt7pYXYN3k8m_AKikM1X4xjvHgv2S9nLR1AajrtO7hNgj1jy-Ws_vinEs7scKe12wQycm7ZQWIpYa2xBL9qVysfs_eoE1EGeKhEJF-DVHRNbz2eXUDd9uTQwlPySuxT7cCHnE1O-klX1BonJC9VDfAk7_joPIoG5MrSOuszozNbA5_GbAqZrp0OyPOIR5ilYDFo2bJFU4CJgmMtW2llOhmE1ATW8-g6b7-37NHEIY2a3zQ1YhGGf-LkcjR5AN68eE_e4MZV1MvzstzlbhL8wXNbGErhf4zcyBFQ1yUiDcaqtUP3SFFCYjeGqPrWVTM5YlrQYNgunDQw1dMoS3_4hxM_u_4fxgpnFZ265GFzfoceVHOokMeDOpeLOO8TGWwf4iRFVzid2Z4GaaUrZqPRBytQPgBxo81sHeCr159qF4ET-HI28g-MTZr-R5x44"
  config.headers.Authorization = token ? JSON.parse(token) : '';
  config.headers['Cache-Controll'] = 'no-cache,private';
  return config;
});

export default instance;

